import { youtubeWatchUrlFromWatchUrl } from "./youtubeVideoId";

export function seekYoutubeViaExtension(
  contentUrl: string,
  timeSec: number,
): boolean {
  const watchUrl = youtubeWatchUrlFromWatchUrl(contentUrl, timeSec);
  if (!watchUrl) return false;
  window.postMessage(
    { type: "podscope-youtube-seek", watchUrl },
    window.location.origin,
  );
  return true;
}

export function toggleManagedYoutubePlayback(): void {
  window.postMessage(
    { type: "podscope-youtube-toggle-playback" },
    window.location.origin,
  );
}

export function toggleManagedYoutubeMute(): void {
  window.postMessage(
    { type: "podscope-youtube-toggle-mute" },
    window.location.origin,
  );
}

export function nudgeManagedYoutubeTime(
  direction: -1 | 1,
  stepSec: number,
): Promise<number | null> {
  const requestId =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random()}`;

  return new Promise((resolve) => {
    const timeout = window.setTimeout(() => {
      window.removeEventListener("message", onResult);
      resolve(null);
    }, 500);

    const onResult = (event: MessageEvent) => {
      if (event.source !== window) return;
      const data = event.data;
      if (
        data?.type !== "podscope-youtube-nudge-result" ||
        data.requestId !== requestId
      ) {
        return;
      }
      window.clearTimeout(timeout);
      window.removeEventListener("message", onResult);
      resolve(
        data.ok && typeof data.currentTime === "number"
          ? data.currentTime
          : null,
      );
    };

    window.addEventListener("message", onResult);
    window.postMessage(
      {
        type: "podscope-youtube-nudge",
        direction,
        stepSec,
        requestId,
      },
      window.location.origin,
    );
  });
}
